export const SET_SHOWING_CALENDAR_DATA = 'SET_SHOWING_CALENDAR_DATA';
export const SET_SHOWING_LIST_DATA = 'SET_SHOWING_LIST_DATA';

export function setShowingCalendarData(data) {
    return function (dispatch) {
        dispatch({ type: SET_SHOWING_CALENDAR_DATA, showingCalendarData: data });
    };
}

export function setShowingListData(data) {
    return function (dispatch) {
        dispatch({ type: SET_SHOWING_LIST_DATA, showingListData: data });
    };
}